export default "__VITE_ASSET__Nachh6Gl__"